import type {CopilotMarkdownExtension} from '@github-ui/copilot-markdown/extension'

import {type NodeMeta, YamlBlockExtension} from '../../yaml-block-extension'
import {DraftIssueTreeBlock, type DraftIssueTreeBlockProps} from './DraftIssueTreeBlock'

const instance = new (class extends YamlBlockExtension<DraftIssueTreeBlockProps> {
  override get dataAttribute(): `data-${string}` {
    return 'data-draft-tree-issue-block'
  }

  override isSupported(node: NodeMeta): boolean {
    return node.lang === 'yaml' && node.type === 'draft-issue-tree'
  }

  override extractProps(node: NodeMeta): DraftIssueTreeBlockProps {
    return {
      data: node.value,
      isStreaming: node.isStreaming ?? false,
    }
  }

  override createComponent(props: DraftIssueTreeBlockProps): React.ReactNode {
    return <DraftIssueTreeBlock {...props} />
  }
})()

export default function draftIssueTreeExtension(): CopilotMarkdownExtension {
  return instance
}
